import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import './Platforms.css';

const MT4: React.FC = () => {

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: { 
      opacity: 1,
    }
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
    }
  };

  return (
    <motion.div 
      className="platforms-page"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
      transition={{ staggerChildren: 0.2 }}
    >
      <div className="container">
        <motion.div className="page-title" variants={itemVariants}>
          <h1>MetaTrader 4 (MT4)</h1>
          <p>World's most popular trading platform for forex and CFDs</p>
        </motion.div>
        
        <motion.div className="platform-intro" variants={itemVariants}>
          <p>MetaTrader 4 is the most widely used trading platform in the world. Known for its user-friendly interface, comprehensive charting capabilities, and strong community of third-party developers.</p>

        </motion.div>
        
        <motion.div className="platform-features" variants={containerVariants}>
          <motion.div className="feature" variants={itemVariants} whileHover={{ scale: 1.03 }} transition={{ type: "spring", stiffness: 300 }}>
            <h3>User-Friendly Interface</h3>
            <p>Intuitive design that makes it suitable for both beginners and experienced traders</p>
          </motion.div>
          
          <motion.div className="feature" variants={itemVariants} whileHover={{ scale: 1.03 }} transition={{ type: "spring", stiffness: 300 }}>
            <h3>Expert Advisors</h3>
            <p>Automated trading systems that can execute trades based on predefined criteria</p>
          </motion.div>
          
          <motion.div className="feature" variants={itemVariants} whileHover={{ scale: 1.03 }} transition={{ type: "spring", stiffness: 300 }}>
            <h3>Custom Indicators</h3>
            <p>Thousands of custom indicators available from the Market and community</p>
          </motion.div>
        </motion.div>
        
        <motion.div className="platform-actions" variants={itemVariants}>
          <h2>Get Started with MT4</h2>
          <p>Choose the broker that best suits your trading style and requirements</p>
          <div className="btn-container">
            <Link to="/ib-partners" className="btn">View Recommended Brokers</Link>
            <Link to="/education" className="btn secondary">Learn More</Link>
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default MT4;